import { render, staticRenderFns } from "./OfferDate.vue?vue&type=template&id=2b98cc1e&"
import script from "./OfferDate.vue?vue&type=script&lang=js&"
export * from "./OfferDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports